module.exports = __webpack_public_path__ + "static/img/bl_hands.c9e49d69.webp";